import { Messages } from '../../../../codegen/Localize';
import { runFlow } from '../../../../flow/actions/RunFlowReduxAction';
import { IContentInfo } from '../../../../ts/models/IContentInfo';
import { IRunFlowAction } from '../../../../ts/ServerApi/types/actionNames';
import { EntityActionNames, IEntityAction } from './IEntityAction';

export const RunFlowEntityAction: IEntityAction<IContentInfo<'flow'>, IRunFlowAction> = {
  name: EntityActionNames.RunNow,
  translateName: Messages.runNow,
  isVisible: () => true,
  isClickable: (availableActions: IRunFlowAction) => !!(availableActions && availableActions.runFlow),
  createReduxAction: (targetItems: IContentInfo[]) => runFlow(targetItems)
};
